import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DskHomeUserStore } from '../../store/dskhome-user';
import { SessionExpiredDialogComponent, SessionExpiredDialogData } from '../../dialogs/session-expired-dialog';
import { API_BASE_URL_TOKEN } from '../../providers/api-providers';

export const dskHomeHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = inject(API_BASE_URL_TOKEN);
  const router = inject(Router);
  const matDialog = inject(MatDialog);
  const dskHomeUserStore = inject(DskHomeUserStore);

  // Skip if the request URL is already absolute
  if (/^(http|https):\/\//.test(req.url)) {
    return next(req);
  }

  // Skip if the request is for media files
  if (req.url.includes('media/')) {
    return next(req);
  }

  // Add credentials to all requests to DSKHome BFF
  const dskHomeBeRequests = req.clone({
    url: `${apiBaseUrl}${req.url}`,
    withCredentials: true
  });

  return next(dskHomeBeRequests).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (dskHomeUserStore.isLoggedIn()) {
          // If user is logged in and 401 error is thrown => credentials are expired
          openSessionExpiredDialog(router, matDialog);
          dskHomeUserStore.feLogout();
        }
      }
      // Re-throw the error so subscribing components can still handle it
      return throwError(() => error);
    })
  );
};

function openSessionExpiredDialog(router: Router, matDialog: MatDialog): void {
  matDialog.open<SessionExpiredDialogComponent, SessionExpiredDialogData>(SessionExpiredDialogComponent, {
    data: {
      // pass router.url as dialog data, because dskHomeUserStore.feLogout() redirects to home page
      // and we need to keep the current page as redirect url
      redirectUrl: router.url,
    },
    autoFocus: true,
    disableClose: true,
  });
}
